import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "open-translation-project-modal-filter-container" }
const _hoisted_2 = { class: "translation-project-table-container" }
const _hoisted_3 = { class: "table translation-project-table" }
const _hoisted_4 = ["onClick"]

import CommonFilter from "@common/components/CommonFilter.vue";
import { TranslationProject } from "@medapro-types/TranslationManager/translationManager";
import { getLanguageDisplayName } from "@util/languages";
import { naturalSort } from "@util/naturalSort";
import { computed, DeepReadonly, reactive } from "vue";

//#region General
type ViewModel = {
  searchTerm: string | null;
  selectedTranslationProject: DeepReadonly<TranslationProject> | null;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenTranslationProjectModal',
  props: {
    show: { type: Boolean },
    translationProjects: {}
  },
  emits: ["update:show", "confirm", "cancel"],
  setup(__props: any, { emit: emits }) {

const props = __props;




//#endregion

//#region ViewModel
const vm = reactive<ViewModel>({
  searchTerm: null,
  selectedTranslationProject: null
});
//#endregion

//#region Data
const sortedTranslationProjects = computed(() => {
  const sorted = naturalSort(props.translationProjects, "name");
  if (vm.searchTerm) {
    return sorted.filter((project) => project.name.includes(vm.searchTerm!));
  }

  return sorted;
});

const selectTranslationProject = (project: DeepReadonly<TranslationProject> | null) => {
  vm.selectedTranslationProject = project;
};

const onConfirm = () => {
  if (vm.selectedTranslationProject) {
    emits("confirm", vm.selectedTranslationProject);
  }
};

const onCancel = () => {
  emits("cancel");
};
//#endregion

//#region Show
const localShow = computed<boolean>({
  get: () => props.show,
  set: (nv) => emits("update:show", nv)
});
//#endregion

return (_ctx: any,_cache: any) => {
  const _component_b_btn = _resolveComponent("b-btn")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.$t('translationManager.openDialog.title'),
    "body-class": "open-translation-project-modal",
    size: "xl",
    modelValue: localShow.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((localShow).value = $event)),
    "header-close-content": "",
    onOk: onConfirm,
    onCancel: onCancel
  }, {
    "modal-footer": _withCtx(({ ok, cancel }) => [
      _createVNode(_component_b_btn, {
        variant: "primary",
        disabled: !vm.selectedTranslationProject,
        onClick: ok
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("Open")), 1)
        ]),
        _: 2
      }, 1032, ["disabled", "onClick"]),
      _createVNode(_component_b_btn, { onClick: cancel }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("close")), 1)
        ]),
        _: 2
      }, 1032, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(CommonFilter, {
          modelValue: vm.searchTerm,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.searchTerm) = $event)),
          placeholder: _ctx.$t('FilterByName'),
          triggerByTime: ""
        }, null, 8, ["modelValue", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("name")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("Catalogue")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("translationManager.sourceLanguage")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("translationManager.targetLanguage")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("UpdatedOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("UpdatedBy")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("CreatedOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("CreatedBy")), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedTranslationProjects.value, (project) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: project.translationProjectId,
                onClick: ($event: any) => (selectTranslationProject(project)),
                class: _normalizeClass({ 'table-active': vm.selectedTranslationProject?.translationProjectId == project.translationProjectId })
              }, [
                _createElementVNode("td", null, _toDisplayString(project.name), 1),
                _createElementVNode("td", null, _toDisplayString(project.catalog.name), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getLanguageDisplayName)(project.sourceLanguage?.languageCode)), 1),
                _createElementVNode("td", null, _toDisplayString(_unref(getLanguageDisplayName)(project.targetLanguage?.languageCode)), 1),
                _createElementVNode("td", null, _toDisplayString(project.updatedOn ? _ctx.$d(project.updatedOn, "shortDateTime") : ""), 1),
                _createElementVNode("td", null, _toDisplayString(project.updatedBy), 1),
                _createElementVNode("td", null, _toDisplayString(project.createdOn ? _ctx.$d(project.createdOn, "shortDateTime") : ""), 1),
                _createElementVNode("td", null, _toDisplayString(project.createdBy), 1)
              ], 10, _hoisted_4))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}
}

})